import { ChevronLeft } from "lucide-react";
import { cn } from "@/utils/cn";

// Single shared style for every "go back" affordance in the app (return to
// home, abort creation, back a step, back to login) — previously each page
// hand-rolled its own button with a different font size/weight/tracking, so
// they read as inconsistent even though they all do the same kind of thing.
export function BackButton({ children = "Return to Home", className, iconSize = 14, ...props }) {
  return (
    <button
      className={cn(
        "group flex items-center gap-1.5 w-fit font-mono text-xs font-bold uppercase tracking-widest text-zinc-500 hover:text-indigo-400 transition-colors",
        className
      )}
      {...props}
    >
      <ChevronLeft size={iconSize} className="transition-transform group-hover:-translate-x-1" />
      {children}
    </button>
  );
}
